import useWindowDimensions from "@/common/hooks/useWindowDimension";
import { PopOverMenuItem } from "./PopOverMenuItem";
import { IGroup, IItem } from "./PopOverMenu";
import { clsx } from "clsx";

import "./style/PopOverMenuList.scss";

export const PopOverMenuList = ({ groupName, groupMobileName, items, className }: IGroup) => {
  const isDesktop = useWindowDimensions();

  return (
    <div className={clsx("PopOverMenuList", className)}>
      {groupName && isDesktop && <h4 className="PopOverMenuList-Title">{typeof groupName === "function" ? groupName() : groupName}</h4>}
      {groupMobileName && !isDesktop && <h4 className="PopOverMenuList-Title">{typeof groupMobileName === "function" ? groupMobileName() : groupMobileName}</h4>}
      <div className="PopOverMenuList-List">
        {items.map(({ icon, onClick, title, disabled, className }: IItem, index: number) => (
          <PopOverMenuItem icon={icon} title={title} disabled={disabled} onClick={onClick} className={className} key={index} />
        ))}
      </div>
    </div>
  );
};
